export default "__VITE_ASSET__D6B1pi96__"